module.exports = __webpack_public_path__ + "static/media/cluster-userflow-1.fa987d7c.jpg";